module.exports = __webpack_public_path__ + "static/sponsor-08-3f71f77df9eb2f64747208e16c349fd8.png";